module.exports = __webpack_public_path__ + "static/media/NCA_new.1cde0d92.jpg";